import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Do not scroll when just switching language between /mx <-> /en on the same page
    const previous = sessionStorage.getItem("fund_prev_path") || "";
    const isLangSwitch = (() => {
      if (!previous) return false;
      const stripLang = (p) => p.replace(/^\/(mx|en)/, "") || "/";
      return stripLang(previous) === stripLang(pathname) && previous !== pathname;
    })();
    sessionStorage.setItem("fund_prev_path", pathname);
    if (!isLangSwitch) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }, [pathname]);
  return null;
};

export default ScrollToTop;
